__turbopack_context__.v({
  "border": "JsLnKG_border",
  "error": "JsLnKG_error",
  "fill": "JsLnKG_fill",
  "large": "JsLnKG_large",
  "light": "JsLnKG_light",
  "link": "JsLnKG_link",
  "medium": "JsLnKG_medium",
  "neutral": "JsLnKG_neutral",
  "primary": "JsLnKG_primary",
  "root": "JsLnKG_root",
  "secondary": "JsLnKG_secondary",
  "small": "JsLnKG_small",
  "success": "JsLnKG_success",
  "underline": "JsLnKG_underline",
  "warning": "JsLnKG_warning",
  "xl": "JsLnKG_xl",
  "xs": "JsLnKG_xs",
  "xxl": "JsLnKG_xxl",
  "xxs": "JsLnKG_xxs",
});
